<template>
  <div>
    <div class="boxDiv">
      <el-form :model="infoData" label-width="120px">
        <div class="lines">
          <i class="el-icon-document"></i>
          讲师基本信息
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="Picture" label="讲师照片">
              <div style="display: block">
                <div v-if="infoData.Picture">
                  <el-avatar
                    shape="square"
                    :size="180"
                    :src="
                      infoData.Picture +
                      '?x-oss-process=image/resize,h_500,w_500,m_fixed'
                    "
                  ></el-avatar>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="Name" label="讲师姓名">
              <el-input
                v-model="infoData.Name"
                placeholder="讲师姓名"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item prop="CompanyName" label="讲师公司名称">
              <el-input
                v-model="infoData.CompanyName"
                placeholder="讲师公司名称"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item prop="PhoneNumber" label="讲师手机号">
              <el-input
                v-model="infoData.PhoneNumber"
                placeholder="讲师手机"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item prop="Email" label="讲师邮箱">
              <el-input
                v-model="infoData.Email"
                placeholder="讲师邮箱"
                maxlength="100"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item prop="Position" label="讲师职位">
              <el-input
                v-model="infoData.Position"
                placeholder="讲师职位"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="insertForm">
            <el-form-item prop="GoodAt" label="讲师擅长领域">
              <el-select
                v-model="infoData.GoodAt"
                placeholder="讲师擅长领域"
                disabled
              >
                <el-option
                  v-for="item in goodatList"
                  :label="item.Name"
                  :value="item.Name"
                  :key="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="UserName" label="讲师对接人">
              <el-select
                v-model="infoData.UserName"
                placeholder="讲师对接人"
                disabled
              >
                <el-option
                  v-for="item in userNameList"
                  :label="item.LoginName"
                  :value="item.LoginName"
                  :key="item.UserId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cascaderCity" label="讲师所在城市">
              <el-cascader
                disabled
                size="large"
                :options="options"
                clearable
                placeholder="请选择讲师所在城市"
                v-model="cascaderCity"
                :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item prop="IsOnline" label="是否线上授课">
              <el-select
                v-model="infoData.IsOnline"
                placeholder="是否可以选择线上授课"
                disabled
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="WeiXinId" label="讲师微信号">
              <el-input
                v-model="infoData.WeiXinId"
                placeholder="讲师微信号"
                maxlength="100"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="divFlex">
          <div class="left">讲师介绍：</div>
          <div class="right" v-html="infoData.Desc"></div>
        </div>
        <div class="divFlex flexMargin">
          <div class="left">课程介绍：</div>
          <div class="right" v-html="infoData.CourseDesc"></div>
        </div>
      </el-form>
      <div class="lines">
        <i class="el-icon-document"></i>
        参加过的活动
      </div>
      <el-table border>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="活动名称"></el-table-column>
        <el-table-column label="举办时间"></el-table-column>
        <el-table-column label="讲师类型"></el-table-column>
        <el-table-column label="签到/报名人数"></el-table-column>
        <el-table-column label="反馈"></el-table-column>
      </el-table>
      <br /><br />
      <div class="lines">
        <i class="el-icon-document"></i>
        合同和协议
        <div class="flexBtn">
          <el-button type="primary" @click="handleContract"
            >新增合同/协议</el-button
          >
        </div>
      </div>
      <el-table border :data="tabContractData" v-loading="contractLoading">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="Name" label="文件名称"></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="上传时间"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="StartTime"
          label="开始时间"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="EndTime"
          label="结束时间"
          width="160"
        ></el-table-column>
        <el-table-column label="是否失效" width="120">
          <template slot-scope="scope">
            <el-switch
              @change="enabledChange(scope)"
              v-model="scope.row.IsDeleted"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="false"
              :inactive-value="true"
              :disabled="scope.row.IsDeleted === true"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150"
          v-if="tableButtonList.length > 0">
          <template slot-scope="scope">
            <span
              v-for="item in tableButtonList"
              :key="item.id"
              style="padding-left: 10px"
            >
              <el-button
                type="text"
                v-bind:key="item.id"
                v-prevent-re-click
                v-if="!item.IsHide && item.order===0"
                @click="callFunc(item, scope.row)"
                >{{ item.name }}</el-button
              >
            </span>
          </template>
        </el-table-column>
      </el-table>

      <br /><br /><br />
      <div class="lines">
        <i class="el-icon-document"></i>
        相关文件留档
        <div class="flexBtn">
          <el-button type="primary" @click="handleFile">新增课件</el-button>
        </div>
      </div>
      <el-table border :data="tabFileData">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="Name" label="文件名称"></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="上传时间"
          width="200"
        ></el-table-column>
        <el-table-column label="操作" width="150"
          v-if="tableButtonList.length > 0">
          <template slot-scope="scope">
            <span
              v-for="item in tableButtonList"
              :key="item.id"
              style="padding-left: 10px"
            >
              <el-button
                type="text"
                v-bind:key="item.id"
                v-prevent-re-click
                v-if="!item.IsHide && item.order===1"
                @click="callFunc(item, scope.row)"
                >{{ item.name }}</el-button
              >
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br /><br />
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item prop="Name" label="文件名称">
          <el-input v-model="ruleForm.Name" placeholder="文件名称"></el-input>
        </el-form-item>
        <el-form-item
          prop="formDate"
          label="合同时间"
          class="is-required"
          v-show="ruleForm.AttachmentType == 1"
        >
          <el-date-picker
            v-model="formDate"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="合同开始日期"
            end-placeholder="合同结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="Url" label="上传文件">
          <div style="display: flex; align-items: center">
            <div class="" v-if="ruleForm.Url">
              <el-link
                :href="ruleForm.Url"
                :disabled="!ruleForm.Url"
                target="_blank"
                type="primary"
                ><i class="el-icon-view el-icon--right"></i>
              </el-link>
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload2"
                v-model="fileList"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload"
                @on-update="handleOnUpdate"
                :accept="accept"
                color="#1890ff"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLecturerInfo,
  AddLecturerAttachment,
  LecturerAttachmentList,
  LecturerDisabled,
} from '../../api/api'
import store from '@/store'
import { provinceAndCityData } from 'element-china-area-data'
import UploadPan from '@/components/Upload/index'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      tableButtonList: [],
      options: provinceAndCityData, // 城市联动数据
      goodatList: [], // 擅长领域
      userNameList: [], // 对接人
      cascaderCity: [], // 城市
      // 显示数据
      infoData: {
        Picture: '',
        Name: '',
        CompanyName: '',
        PhoneNumber: '',
        Position: '',
        Email: '',
        GoodAt: '',
        UserName: '',
        UserId: 0,
        Province: '', // 省份
        CityCode: '', // 城市
        IsOnline: '',
        Desc: '',
        CourseDesc: '',
        WeiXinId: '',
      },
      tabContractData: [], // 合同数据
      contractLoading: false,
      tabFileData: [], // 文件数据
      dialogVisible: false,
      dialogTitle: '新增附件', // 弹窗标题
      formDate: [], // 合同时间
      // 新增弹窗
      ruleForm: {
        LecturerId: store.getters.getCurLecturerId,
        AttachmentType: '',
        Name: '',
        Url: '',
        StartTime: '',
        EndTime: '',
      },
      rules: {
        Name: [{ required: true, message: '请输入文件名称', trigger: 'blur' }],
        Url: [{ required: true, message: '请上传文件', trigger: 'blur' }],
      },
      fileList: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.PDF,.DOC,.DOCX,.pdf,.doc,.docx',
    }
  },
  components: {
    UploadPan,
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 显示数据
    handleQuery() {
      if (!store.getters.getCurLecturerId) {
        this.ruleForm = ''
      } else {
        // 显示基本信息
        getLecturerInfo(store.getters.getCurLecturerId).then((res) => {
          if (res.data.success) {
            this.infoData = res.data.response
            this.cascaderCity = res.data.response.CityCode
          }
        })

        LecturerAttachmentList(store.getters.getCurLecturerId).then((res) => {
          if (res.data.success) {
            let arr = res.data.response
            // 显示合同/协议 信息
            let resultContract = arr.filter(function (types) {
              return types.AttachmentType <= 1
            })
            this.tabContractData = resultContract

            // 显示留档文件 信息
            let resultFile = arr.filter(function (types) {
              return types.AttachmentType > 1
            })
            this.tabFileData = resultFile
          }
        })
      }
    },

    // 点击 合同新增按钮
    handleContract() {
      this.dialogTitle = '新增合同/协议文件'
      this.ruleForm.AttachmentType = 1
      this.dialogVisible = true
    },

    // 点击 文件新增按钮
    handleFile() {
      this.dialogTitle = '新增留档文件'
      this.ruleForm.AttachmentType = 2
      this.dialogVisible = true
    },

    // 弹窗提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.formDate.length > 1) {
          this.ruleForm.StartTime = this.formDate[0]
          this.ruleForm.EndTime = this.formDate[1]
        } else {
          this.ruleForm.StartTime = this.ruleForm.EndTime = ''
        }
        if (!this.ruleForm.StartTime && this.ruleForm.AttachmentType == 1) {
          this.$message({
            message: '请选择合同时间',
            type: 'error',
          })
          return false
        }

        if (valid) {
          AddLecturerAttachment(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.dialogVisible = false
              this.formDate = []
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 弹窗关闭
    handleClose() {
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields()
    },

    // 下载合同、协议文件
    downloadContractFile(){
      const token = window.localStorage.getItem('Token')
      const url = this.currentRow.Url
      if (token) {
        window.location.href = url
      } else {
        this.$message({
          message: '请联系管理员',
          type: 'error',
        })
      }
    },
    // 下载留档文件
    downloadFile() {
      const token = window.localStorage.getItem('Token')
      const url = this.currentRow.Url
      if (token) {
        window.location.href = url
      } else {
        this.$message({
          message: '请联系管理员',
          type: 'error',
        })
      }
    },

    // 合同是否失效
    enabledChange(scope) {
      LecturerDisabled(scope.row.Id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.Url = url
    },
  },
  mounted() {
    this.handleQuery()
    
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>

<style>
.boxDiv {
  display: block;
  width: 100%;
}
.lines {
  border-bottom: 2px solid #00623b;
  padding: 5px 20px 5px 0;
  font-size: 18px !important;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.lines i {
  font-size: 20px !important;
}
.divFlex {
  display: flex;
  flex-wrap: nowrap;
}
.divFlex .left {
  width: 120px;
  text-align: right;
  font-size: 20px !important;
  line-height: 22px !important;
  font-weight: bold;
}
.divFlex .right {
  flex: 1;
  padding: 0 30px 0 0;
}
p {
  font-size: 14px !important;
  line-height: 22px !important;
  text-align: justify;
  margin-bottom: 15px;
}
p strong {
  font-size: 14px !important;
  line-height: 22px !important;
}
.flexMargin {
  margin: 30px 0;
}
.flexBtn {
  display: inline-flex;
  position: absolute;
  top: -8px;
  right: 16px;
}

.insertForm .el-select,
.insertForm .el-cascader {
  width: 100%;
}
</style>
